(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('shadowItRiskChart', ["path", "securityEventsDao", "timeResolutions", "defaultChartColorList", "routeHelper", "severityTypes", function (path, securityEventsDao, timeResolutions, defaultChartColorList, routeHelper, severityTypes) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('shadow-it/risk-chart').template('risk-chart'),
            scope: {
                saasList: '=',
                resolution: '=',
                eventStates: '='
            },
            link: function ($scope) {
                var riskLevels = _(severityTypes.data).reduce(function (memo, item) {
                    memo[item.id] = item;
                    return memo;
                }, {});
                var linkParams;
                function generatePath(riskLevel) {
                    return routeHelper.getPath('shadow-it-apps', {}, $.extend({ risk_level: riskLevel }, linkParams));
                }
                $scope.model = {
                    flotOptions: {
                        series: {
                            bars: {
                                show: true,
                                horizontal: false,
                                align: 'center',
                                barWidth: 0.1,
                                fill: 1
                            }
                        },
                        colors: defaultChartColorList,
                        grid: {
                            hoverable: true,
                            clickable: true,
                            borderWidth: 1,
                            tickColor: '#fff',
                            borderColor: '#eee'
                        },
                        legend: { show: false },
                        xaxis: {
                            ticks: [
                                1,
                                2,
                                3,
                                4,
                                5
                            ],
                            tickFormatter: function (text) {
                                if (!riskLevels[text]) {
                                    return '';
                                }
                                return '<a href="' + routeHelper.pathToHref(generatePath(text)) + '">' + riskLevels[text].label + '</a>';
                            },
                            min: 0.5,
                            max: 5.5
                        },
                        tooltip: true,
                        tooltipOpts: {
                            defaultTheme: false,
                            content: '%y.0 applications with severity %s',
                            shifts: {
                                x: 0,
                                y: 20
                            }
                        }
                    }
                };
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    var resolution = timeResolutions.get($scope.resolution);
                    var q = securityEventsDao.list().params({
                        groupBy: 'risk_level',
                        filterEnum_saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(','),
                        filterEnum_type: 'shadow_it',
                        afterColumn: 'create_time',
                        afterStep: resolution.id,
                        afterFromNow: true,
                        afterMax: 1,
                        groupByAggrColumn: 'shadow_it_application',
                        groupByAggrColumnDistinct: true
                    });
                    linkParams = {
                        resolution: resolution.id,
                        saas: _($scope.saasList).map(function (saas) {
                            return saas.name;
                        }).join(',')
                    };
                    if ($scope.eventStates) {
                        q = q.params({ filterEnum_current_state: $scope.eventStates.join(',') });
                        linkParams.states = $scope.eventStates.join(',');
                    }
                    return q.order('count', 'desc').then(function (response) {
                        $scope.model.data = _(response.data.rows).map(function (row) {
                            return {
                                color: riskLevels[row.risk_level].color,
                                label: row.risk_level,
                                data: [[
                                        row.risk_level,
                                        row.count
                                    ]],
                                link: generatePath(row.risk_level)
                            };
                        });
                    });
                };
                $scope.$watchGroup([
                    'resolution',
                    'saasList',
                    'eventStates'
                ], function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());